import { render, staticRenderFns } from "./small-report-card.vue?vue&type=template&id=6d2f2fc0&scoped=true&"
import script from "./small-report-card.vue?vue&type=script&lang=js&"
export * from "./small-report-card.vue?vue&type=script&lang=js&"
import style0 from "./small-report-card.vue?vue&type=style&index=0&id=6d2f2fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f2fc0",
  null
  
)

export default component.exports